import { render } from "./SalesBaitTable.vue?vue&type=template&id=8bae3a34"
import script from "./SalesBaitTable.vue?vue&type=script&lang=js"
export * from "./SalesBaitTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__